import React, { useEffect, useState } from "react";
import axios from "axios";

function CreateRoomForm() {
  const [floors, setFloors] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState("");
  const [popup, setPopup] = useState("");

  const emailId = "john@example.com";

  useEffect(() => {
    fetchFloors();
  }, []);

  const fetchFloors = async () => {
    try {
      const res = await axios.get(
        `http://localhost:9777/floor_rooms/getFloors?emailId=${emailId}`,
      );

      if (res.data.statusCode === 200) {
        setFloors(res.data.data);
      }
    } catch (err) {
      showPopup("Failed to load floors");
    }
  };

  const showPopup = (msg) => {
    setPopup(msg);
    setTimeout(() => setPopup(""), 2000);
  };

  const handleCreateRoom = async () => {
    if (!selectedFloor) {
      showPopup("Please select a floor");
      return;
    }

    const floor = floors.find((f) => f.floorId === Number(selectedFloor));

    const payload = {
      roomName: "", // backend generates next room
      floorId: floor.floorId,
      floorName: floor.floorName,
      createdBy: emailId,
    };

    try {
      const res = await axios.post(
        "http://localhost:9777/floor_rooms/createRoom",
        payload,
      );

      if (res.data.message) {
        showPopup(res.data.message); // e.g. F1-R3 created
      }
    } catch (err) {
      showPopup("Failed to create room");
    }
  };

  return (
    <div style={styles.container}>
      {popup && <div style={styles.popup}>{popup}</div>}

      <div style={styles.card}>
        <h2 style={styles.title}>Create Room</h2>

        <div style={styles.row}>
          {/* FLOOR DROPDOWN */}
          <select
            style={styles.select}
            value={selectedFloor}
            onChange={(e) => setSelectedFloor(e.target.value)}
          >
            <option value="">Select Floor</option>
            {floors.map((f) => (
              <option key={f.floorId} value={f.floorId}>
                {f.floorName}
              </option>
            ))}
          </select>

          {/* CREATE BUTTON */}
          <button style={styles.addBtn} onClick={handleCreateRoom}>
            + Add Room
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateRoomForm;

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f4f6f8",
  },

  card: {
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    width: "400px",
  },

  title: {
    textAlign: "center",
    marginBottom: "20px",
  },

  row: {
    display: "flex",
    gap: "10px",
  },

  select: {
    flex: 1,
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },

  addBtn: {
    padding: "10px 15px",
    background: "#16a34a",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  popup: {
    position: "fixed",
    top: "20px",
    right: "20px",
    background: "#000",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "6px",
  },
};
